import firebaseApp from "./firebase";
import firestore from "firebase/compat/firestore";

// export firestore database
export default firebaseApp.firestore();
